import { useState } from 'react';
import { LogOutIcon } from 'lucide-react';

import { ModalComponent } from '@/components/modal';
import { ConfirmModal } from '@/components/modals/confirm-modal';
import { useLogoutMutation } from '@/query/auth';

function LogoutButton() {
  const [isOpen, setIsOpen] = useState(false);
  const mutation = useLogoutMutation();

  const handleConfirm = () => {
    if (mutation.isPending) return;
    mutation.mutate();
  };

  return (
    <>
      <button
        type="button"
        className="nav-item"
        title="Logout"
        aria-label="Logout"
        onClick={() => setIsOpen(true)}
      >
        <LogOutIcon size={26} />
      </button>
      <ModalComponent
        title="Sign out?"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        body={
          <ConfirmModal
            message="You'll need to log in again."
            confirmLabel="Sign out"
            destructive
            isPending={mutation.isPending}
            onConfirm={handleConfirm}
            onCancel={() => setIsOpen(false)}
          />
        }
      />
    </>
  );
}

export { LogoutButton };
